<!-- Trigger para agregar el campo -->
<div *ngIf="!isVisible()" class="optional-field-trigger">
  <button mat-button type="button" (click)="onAdd()">
    <mat-icon>add</mat-icon>
    {{ triggerLabel }}
  </button>
</div>

<!-- Contenido del campo cuando está visible -->
<div *ngIf="isVisible()" class="optional-field-with-remove">
  <ng-content></ng-content>
  <button 
    mat-icon-button 
    type="button" 
    (click)="onRemove()" 
    [matTooltip]="removeTooltip"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
